import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UploadTemplateComponent } from './components/upload-template/upload-template.component';
import { UploadProgressComponent } from './components/upload-progress/upload-progress.component';
import { UploadSuccessComponent } from './components/upload-success/upload-success.component';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { ProgressBarModule } from '../progress-bar/progress-bar.module';
import { UploadFileComponent } from './upload-file.component';
import { FileUploadModule } from 'ng2-file-upload';
import { UploadUnsuccessComponent } from './components/upload-unsuccess/upload-unsuccess.component';

@NgModule({
  declarations: [
    UploadFileComponent,
    UploadTemplateComponent,
    UploadProgressComponent,
    UploadSuccessComponent,
    UploadUnsuccessComponent,
  ],
  exports: [UploadFileComponent],
  imports: [CommonModule, SvgIconModule, ProgressBarModule, FileUploadModule],
})
export class UploadFileModule {}
